// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"d0e24115","312":"cfe98f9a","408":"dc08d674","476":"f14ce0f3","798":"7843c036"}[chunkId] + ".chunk.css";
};